export const BUSY_DELAY = 600;
export const ENTER_DELAY = 1000;
